import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './DresscodeList.html?raw';

import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import EntityStore from '../../../moreCore/Tools/EntityStore';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import lang from 'dojo/_base/lang';
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import { SelectEntityDialogTypes } from "../../../moreCore/_loadingHelpers/SelectEntityDialog";
import { StringHelpers } from "../../../more/Helpers";
import GenericEntityView from '../../../moreCore/UI/EntityBased/EntityView/GenericEntityView';

class DresscodeList extends compose(_StatefulSection, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    bookingID: string;

    tableContainer: HTMLDivElement;

    store: MdsLax<InstanceType<typeof EntityStore<any>>>;

    table: MdsLax<InstanceType<typeof StaticTable>>;

    rowConfig: StaticTable.RowConfig = {
        attributes: [
            "ref_dress_code.description"
        ],
        colNamesInternal: [
            "ref_address_code.description"
        ],
        headings: [
            "General_Label_Description"
        ]
    };

    tableLayout: StaticTable.Layout = {
        rows: [(this as any).rowConfig],
        label: "table",
        name: "table"
    }

    private _onClickReloadButton() {
        this.StandbyStart();
        this.RequestManager.callfunction("Webtool_EvBookings__LoadDresscodeData", { bookingID: this.bookingID }, lang.hitch(this, this._onReloadResponse), lang.hitch(this, this._onReloadError));
    }

    private _onReloadResponse(response) {
        this.StandbyStop();
        this.store.setup(response);
        this.emit("reload");
    }

    private _onReloadError(error) {
        this.StandbyStop();
        console.error(error);
    }

    private _onClickNewButton(evt: MouseEvent) {
        this.openSelectEntityDialog(evt, "dresscode", lang.hitch(this, this._onSEDCallback), null, { bookingID: this.bookingID });
    }

    private _setupTable() {
        this.table = new StaticTable();
        this.table.setLayout(this.tableLayout);
        this.table.addDefaultRowActionButton("delete");
        this.table.addDefaultRowActionButton("view", lang.hitch(this, this._onClickView));
        this.table.setupFromStore(this.store);
        this.table.placeAt(this.tableContainer);
        this.table.setCyAttribute("dresscodeList");
    }

    private _onSEDCallback(mode: string, data: Array<string>, items: Array<SelectEntityDialogTypes.Item<any>>) {
        switch (mode) {
            case "dresscode":
                if (items && items.length > 0) {
                    for (let item of items) {
                        var entity = item.entry.data;
                        if (this._hasStoreEntity(entity)) {
                            this.showToast(this.translate("DresscodeList_Error_EntityInStore"), "fas fa-warning-triangle");
                        } else {
                            let newHtEntity = {
                                ID: StringHelpers.randomID(),
                                ref_dress_code: entity,
                                ref_booking: { ID: this.bookingID },
                            }

                            this.store.addEntry(newHtEntity);
                        }
                    }
                }
                break;
        }
    }

    private _hasStoreEntity(entity) {
        let completelist = this.store.getCurrentCompleteList();

        for (let item of completelist) {
            if (item.ref_dress_code.ID === entity.ID) return true;
        }

        return false;
    }

    private _onChangeStore() {
        this.emit("change", this.store.getDiffData());
    }

    private _onClickView(rowGroup: StaticTable.StaticTableRowGroup<any>) {
        let entity = rowGroup.entity;
        console.log(entity);
        let dresscode = entity ? entity.ref_dress_code : null;

        if (!dresscode) return;

        let view = new GenericEntityView();
        view.setup(dresscode.ID, dresscode.Classname, dresscode.description, "description");
    }

    hasData(): boolean {
        let data = this.store.getCurrentCompleteList();
        return data.length > 0;
    }

    setBookingID(bookingID: string): void {
        this.bookingID = bookingID;
    }

    afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);

        let dresscode = this.getAttributeValue("___root");
        this.store.setup(dresscode);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.setStartupState("ready");

        this.store = new EntityStore();
        this.store.on("change", lang.hitch(this, this._onChangeStore));
        this._setupTable();

        this.SEDconfigCallfunction = "Webtool_API_EvBookings_SED__GetDresscodeConfig";
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(DresscodeList);